<template>
  <div class="activity_detail_container">
    <template003 :activityInfo="activityInfo" v-if="!!activityInfo && template == '003'"></template003>
    <template002 :activityInfo="activityInfo" v-if="!!activityInfo && template == '002'"></template002>
    <template001 :activityInfo="activityInfo" v-else-if="!!activityInfo"></template001>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat,addH5Escalate } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import commApi from "@/api/apis/common.js";
import template001 from "./templates/template001";
import template002 from "./templates/template002";
import template003 from "./templates/template003";
export default {
  name: "ActivityDetail",
  data() {
    return {
      template: "001",
      params: {
        contentType: null,
        activityId: null,
        cId: null,
      },
      activityInfo: null, //活动详情
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["nodeCode"]),
  },
  components: {
    template001,
    template002,
    template003,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/activity_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      var desc = _this.activityInfo.summaryStatus && _this.activityInfo.summarySth ? _this.activityInfo.summarySth : _this.activityInfo.description;
      if(!desc || desc.length==0){
        desc = _this.activityInfo.activityName;
      }
      
      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.activityInfo.activityName, desc, _this.shareUrl, _this.activityInfo.sharePictureUrl);
        this.$emit('initWeiXinTicket');
      }).catch((err) => {

      })
    },
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.activityInfo = res.data;
            // 中宣部埋点：首页页面浏览（活动）
            _this.$track.trackPageViewOnce(
              _this.$track.EVENT_CODE.HOME_PG,
              _this.$track.mapArticleProps(_this.activityInfo, {
                pageName: "活动详情页",
                pageId: "activity_detail",
                extra: { article_type: "活动" },
              })
            );
            _this.wechatShare(); // 微信二次分享
            addH5Escalate();
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      this.params.contentType = Number(query.contentType) || 1;
      this.params.activityId = Number(query.activityId);
      this.params.cId = Number(query.cId) || 0;
      this.getActivityDetail();
      loadStat(); // 友盟统计
    } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.params.contentType = Number(query.contentType) || 1;
      this.params.activityId = Number(query.contentId);
      this.params.cId = Number(query.cId) || 0;
      this.getActivityDetail();
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.activity_detail_container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>